import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "ion-margin-bottom" }, "Add individual visitors", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("b", null, "Name *", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("b", null, "Email *", -1)
const _hoisted_5 = { class: "container" }

import { addCircle, close, arrowBack } from "ionicons/icons";
import {
  IonPage,
  IonContent,
  IonIcon,
  IonList,
  IonSelect,
  IonSelectOption,
  IonNote,
  IonLoading,
  IonButton,
  IonGrid,
  IonRow,
  IonCol,
  IonLabel,
  IonItem,
  IonInput,
  IonFooter,
  onIonViewWillEnter,
} from "@ionic/vue";
import { useContextStore } from "@/stores/context";
import router from "@/router";
import countries from "countries-list";
import { useVisitors } from ".";
import { useWindowWidth } from "@/composition/window";


export default /*#__PURE__*/_defineComponent({
  __name: 'NewVisitor',
  setup(__props) {

const { isMobile } = useWindowWidth();

const countriesOptions = Object.keys(countries.countries).map((key) => ({
  label: countries.countries[key].name,
  value: key,
}));

const contextStore = useContextStore();

const { state, form, emptyFieldsPresent, loadVisitorTypes, create, clear } =
  useVisitors();

onIonViewWillEnter(() => {
  loadVisitorTypes();
  clear();
});

const submit = () => {
  create().then(() => {
    router.push(`/event/${contextStore.event.id}/visitors`);
    contextStore.addEventRegistration();
  });
};

return (_ctx: any,_cache: any) => {
  const _component_ion_fab_button = _resolveComponent("ion-fab-button")!

  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", {
              class: "flex-desktop",
              style: _normalizeStyle([{"align-items":"center"}, _unref(isMobile) ? '' : 'position: relative; left: -75px;'])
            }, [
              (!_unref(isMobile))
                ? (_openBlock(), _createBlock(_component_ion_fab_button, {
                    key: 0,
                    color: "primary",
                    style: {"margin-right":"20px"},
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), { icon: _unref(arrowBack) }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _hoisted_2
            ], 4),
            _createVNode(_unref(IonList), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonItem), {
                  class: _normalizeClass({ 'ion-invalid': _unref(state).errors.name.length > 0 })
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), { position: "stacked" }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonInput), {
                      placeholder: "John Doe",
                      modelValue: _unref(form).name,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).name) = $event)),
                      required: ""
                    }, null, 8, ["modelValue"]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).errors.name, (message, i) => {
                      return (_openBlock(), _createBlock(_unref(IonNote), {
                        slot: "error",
                        key: `name-error-${i}`
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(message), 1)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["class"]),
                _createVNode(_unref(IonItem), {
                  class: _normalizeClass({ 'ion-invalid': _unref(state).errors.email.length > 0 })
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), { position: "stacked" }, {
                      default: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonInput), {
                      type: "email",
                      placeholder: "john.doe@gmail.com",
                      modelValue: _unref(form).email,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).email) = $event)),
                      required: ""
                    }, null, 8, ["modelValue"]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).errors.email, (message, i) => {
                      return (_openBlock(), _createBlock(_unref(IonNote), {
                        slot: "error",
                        key: `email-error-${i}`
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(message), 1)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["class"]),
                _createVNode(_unref(IonItem), {
                  class: _normalizeClass({ 'ion-invalid': _unref(state).errors.phone_number.length > 0 })
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), { position: "stacked" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Phone number")
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonInput), {
                      type: "tel",
                      placeholder: "+1 123 456 7890",
                      modelValue: _unref(form).phone_number,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).phone_number) = $event))
                    }, null, 8, ["modelValue"]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).errors.phone_number, (message, i) => {
                      return (_openBlock(), _createBlock(_unref(IonNote), {
                        slot: "error",
                        key: `phone-error-${i}`
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(message), 1)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["class"]),
                _createVNode(_unref(IonItem), {
                  class: _normalizeClass({ 'ion-invalid': _unref(state).errors.birthdate.length > 0 })
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), { position: "stacked" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Birth date")
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonInput), {
                      type: "date",
                      placeholder: "Microsoft",
                      modelValue: _unref(form).birthdate,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).birthdate) = $event))
                    }, null, 8, ["modelValue"]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).errors.birthdate, (message, i) => {
                      return (_openBlock(), _createBlock(_unref(IonNote), {
                        slot: "error",
                        key: `phone-error-${i}`
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(message), 1)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["class"]),
                _createVNode(_unref(IonItem), {
                  class: _normalizeClass({ 'ion-invalid': _unref(state).errors.company.length > 0 })
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), { position: "stacked" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Company")
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonInput), {
                      type: "text",
                      placeholder: "Microsoft",
                      modelValue: _unref(form).company,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(form).company) = $event))
                    }, null, 8, ["modelValue"]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).errors.company, (message, i) => {
                      return (_openBlock(), _createBlock(_unref(IonNote), {
                        slot: "error",
                        key: `company-error-${i}`
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(message), 1)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["class"]),
                _createVNode(_unref(IonItem), {
                  class: _normalizeClass({ 'ion-invalid': _unref(state).errors.job_title.length > 0 })
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), { position: "stacked" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Job title")
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonInput), {
                      type: "text",
                      placeholder: "Lead Software Developer",
                      modelValue: _unref(form).job_title,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(form).job_title) = $event))
                    }, null, 8, ["modelValue"]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).errors.job_title, (message, i) => {
                      return (_openBlock(), _createBlock(_unref(IonNote), {
                        slot: "error",
                        key: `job-error-${i}`
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(message), 1)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["class"]),
                _createVNode(_unref(IonItem), {
                  class: _normalizeClass({ 'ion-invalid': _unref(state).errors.country.length > 0 })
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), { position: "stacked" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Country")
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonSelect), {
                      placeholder: "Select your country",
                      modelValue: _unref(form).country,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(form).country) = $event))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(countriesOptions), (option) => {
                          return (_openBlock(), _createBlock(_unref(IonSelectOption), {
                            value: option.value,
                            key: `country-option-${option.value}`
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(option.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).errors.country, (message, i) => {
                      return (_openBlock(), _createBlock(_unref(IonNote), {
                        slot: "error",
                        key: `job-error-${i}`
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(message), 1)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["class"]),
                (_unref(state).visitor_types.length > 0)
                  ? (_openBlock(), _createBlock(_unref(IonItem), {
                      key: 0,
                      class: _normalizeClass({ 'ion-invalid': _unref(state).errors.visitor_type.length > 0 })
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonLabel), { position: "stacked" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Visitor type")
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonSelect), {
                          placeholder: "Select visitor type",
                          modelValue: _unref(form).visitor_type,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(form).visitor_type) = $event))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).visitor_types, (visitor_type) => {
                              return (_openBlock(), _createBlock(_unref(IonSelectOption), {
                                value: visitor_type.id,
                                key: `visitor-type-${visitor_type.id}`
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(visitor_type.name), 1)
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).errors.visitor_type, (message, i) => {
                          return (_openBlock(), _createBlock(_unref(IonNote), {
                            slot: "error",
                            key: `type-error-${i}`
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(message), 1)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["class"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (!_unref(isMobile))
              ? (_openBlock(), _createBlock(_unref(IonButton), {
                  key: 0,
                  expand: "block",
                  style: {"width":"250px","margin":"30px auto"},
                  color: "primary",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (submit())),
                  disabled: _unref(emptyFieldsPresent)
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), {
                      slot: "start",
                      icon: _unref(addCircle)
                    }, null, 8, ["icon"]),
                    _createTextVNode(" Register ")
                  ]),
                  _: 1
                }, 8, ["disabled"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }),
      (_unref(isMobile))
        ? (_openBlock(), _createBlock(_unref(IonFooter), { key: 0 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("section", null, [
                  _createVNode(_unref(IonGrid), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonRow), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonCol), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonButton), {
                                expand: "block",
                                color: "light",
                                onClick: _cache[10] || (_cache[10] = ($event: any) => (_unref(router).back()))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(IonIcon), {
                                    slot: "start",
                                    icon: _unref(close)
                                  }, null, 8, ["icon"]),
                                  _createTextVNode(" Cancel ")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(IonCol), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonButton), {
                                expand: "block",
                                color: "primary",
                                onClick: _cache[11] || (_cache[11] = ($event: any) => (submit())),
                                disabled: _unref(emptyFieldsPresent)
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(IonIcon), {
                                    slot: "start",
                                    icon: _unref(addCircle)
                                  }, null, 8, ["icon"]),
                                  _createTextVNode(" Register ")
                                ]),
                                _: 1
                              }, 8, ["disabled"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_unref(IonLoading), {
        "is-open": _unref(state).loading,
        message: "Please wait..."
      }, null, 8, ["is-open"])
    ]),
    _: 1
  }))
}
}

})